 
// src/redux/payments/receipts/slice.ts
import { createSlice } from '@reduxjs/toolkit';
import { ReceiptsState } from './types';
import { fetchReceipts, downloadReceiptFile } from './thunk';

const initialState: ReceiptsState = {
  data: [],
  count: 0,
  next: null,
  previous: null,
  loading: false,
  error: null,
  downloadLoading: false,
  downloadError: null,
};

const receiptsSlice = createSlice({
  name: 'payments/receipts',
  initialState,
  reducers: {
    resetReceiptsState: () => initialState,
    clearReceiptsError: (state) => {
      state.error = null;
    },
    clearReceiptDownloadError: (state) => {
      state.downloadError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch receipts
      .addCase(fetchReceipts.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchReceipts.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.count = payload.count;
        state.next = payload.next;
        state.previous = payload.previous;
        state.data = payload.results;
      })
      .addCase(fetchReceipts.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload ?? 'Failed to load receipts';
      })

      // Download receipt file (same lifecycle as invoices)
      .addCase(downloadReceiptFile.pending, (state) => {
        state.downloadLoading = true;
        state.downloadError = null;
      })
      .addCase(downloadReceiptFile.fulfilled, (state) => {
        state.downloadLoading = false;
        state.downloadError = null;
      })
      .addCase(downloadReceiptFile.rejected, (state, { payload }) => {
        state.downloadLoading = false;
        state.downloadError = payload ?? 'Failed to download receipt';
      });
  },
});

export const {
  resetReceiptsState,
  clearReceiptsError,
  clearReceiptDownloadError,
} = receiptsSlice.actions;

export default receiptsSlice.reducer;
